@if (isAuthenticated) {
  <app-logged-in-navlist [isShowing]="isShowing" [sidenavRef]="sidenavRef"></app-logged-in-navlist>
}
@if (!isAuthenticated) {
  <app-logged-out-navlist [isShowing]="isShowing" [sidenavRef]="sidenavRef"></app-logged-out-navlist>
}